module.exports = __webpack_public_path__ + "img/map.c3ea0845.png";